import React from 'react';
import {connect} from "react-redux";
import {Button, Card, Col, DatePicker, Divider, Popover, Row} from "antd";
import {NavLink} from "react-router-dom";
import Fuse from "fuse.js";
import PropTypes from 'prop-types';
import SearchBox from "../../Boilerplate/SearchBox";
import ExpandedList from "../../Boilerplate/ExpandedList";
import moment from "moment";
import UserSmall from "../../Boilerplate/UserSmall";
import {canCreateSub, canDelete} from "../../Boilerplate/permissions";
import {separatorJoin} from "../../Boilerplate/utilities";
import {compArr, subViewSelector} from "../selectors";
import {setViewPath} from "../../../actions/view";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {compose} from "redux";
import {DeleteButton} from "../DeleteButton";
import {deleteMeetingMinutes, getMeetingMinutesMultiple} from "../../../actions/meetingMinutes";
import DateTimeDisplay from "../../Boilerplate/DateTimeDisplay";

const filterState = {
  filterKeys: null,
  filterActive: false,
  dateRange: [],
};

class MeetingMinuteList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {...filterState};
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) { onMount(); }
  }

  setFilter = (phrase) => {
    if (phrase !== '') {
      let { meetingMinutes } = this.props;
      meetingMinutes = meetingMinutes || [];
      const options = {
        keys: [
          'resource.summary',
        ],
        threshold: 0.3,
        id: 'resource.id'
      };
      let fuse = new Fuse(meetingMinutes, options);
      this.setState({
        filterKeys: fuse.search(phrase),
        filterActive: true,
      });
    } else {
      this.setState({
        filterKeys: [],
        filterActive: false,
      });
    }
  };

  setDateRange = (range) => {
    this.setState({ dateRange: range });
  };

  clearDateRange = () => this.setDateRange(filterState.dateRange);

  checkFilters = () => {
    let { dateRange } = this.state;
    const [from, to] = dateRange;

    let newFilters = {};
    if (!compArr(dateRange, filterState.dateRange)) {
      if (from) newFilters.from = moment(from).startOf('day').format();
      if (to) newFilters.to = moment(to).endOf('day').format();
    }

    return newFilters;
  };

  render() {
    let { meetingMinutes, project } = this.props;
    meetingMinutes = meetingMinutes || [];

    const { filterKeys, filterActive, dateRange } = this.state;
    const [from, to] = dateRange;
    const hasRange = from || to;
    if (dateRange[0]) {
      meetingMinutes = meetingMinutes.filter(meeting => moment(meeting.resource.meetingdatetime).isBetween(dateRange[0], dateRange[1], 'day', '[]'));
    }
    if (filterActive) {
      meetingMinutes = meetingMinutes.filter(item => filterKeys.includes(item.resource.id));
    }

    let index = meetingMinutes.map(i=>i.resource);
    index.sort((a, b) => b.meetingdatetime-a.meetingdatetime);
    index = index.map(i=>i.id);

    const isEmpty = obj => { for (let x in obj) { return false; } return true; };

    const renderFilterControls = () => <div className='bid-listing-control'>
      <DatePicker.RangePicker
        className='control-box'
        key='date-search'
        value={dateRange}
        onChange={range => this.setDateRange(range)}
        format='MM/DD/YYYY'
        style={{width: 400}}
      />
    </div>;


    return (
      <React.Fragment>
        <Row gutter={16}>
        <Card>
          <div className="bid-listing-header">
            <h1>Meeting Minutes</h1>
            <SearchBox
              className='control-box control-search'
              placeholder='search meeting minutes'
              onChange={value => this.setFilter(value)}
            />
          </div>
          <Divider/>
          <ExpandedList
            items={meetingMinutes}
            index={index}
            derivedKey={item => item.resource.id}
            extra={(<React.Fragment>
              <Popover placement='bottom' content={renderFilterControls()} trigger='click'>
                <Button icon='filter' className={(!isEmpty(this.checkFilters())) && 'background-primary-1 color-grayscale-3'}>
                  <span className='hidden inline visible-lg'>Filter</span>
                </Button>
              </Popover>
              <Button type='primary' icon='plus' onClick={this.props.onNew} disabled={!canCreateSub('meetingminutes')(project)}>New Meeting Minutes</Button>
            </React.Fragment>)}
            subExtra={<div>
              {hasRange && <Button className={'clear-filter'} size="small" onClick={this.clearDateRange}>Clear Calendar Filter</Button>}
            </div>}
            renderHeading={() => (
              <Row className='bid-listing-heading text-column'>
                <Col span={9}>Meeting Entry</Col>
                <Col span={7}>Created By</Col>
                <Col span={8}>Next Meeting</Col>
              </Row>
            )}
            renderTop={meetingMinutes => {
              let options = [];
              if (canDelete(meetingMinutes)) options.push(<DeleteButton fauxKey={'delete-' + meetingMinutes.resource.id} icon='delete'
                    title='Delete Meeting Minutes' document={meetingMinutes} onDelete={this.props.onDelete} type='meeting minutes record'/>);
              return (
                <Row justify='space-between' className='bid-listing-content'>
                  <Col span={9}>
                    <NavLink to={meetingMinutes.resource.id}>#{meetingMinutes.resource.number} - <DateTimeDisplay
                      date={meetingMinutes.resource.meetingdatetime}/></NavLink>
                  </Col>
                  <Col span={7}>
                    <UserSmall id={meetingMinutes.resource.createdbyuserid}/>
                  </Col>
                  <Col span={6}>
                    <DateTimeDisplay date={meetingMinutes.resource.nextmeetingdatetime}/>
                  </Col>
                  <Col span={2}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      {separatorJoin(options, <span> | </span>)}
                    </div>
                  </Col>
                </Row>
              );
            }}
            renderContent={meetingMinutes => (
              <div className='bid-listing-full-content'>
              <Row gutter={24}>
                <Col span={18}>
                  <strong>Meeting Notes</strong>
                  <p className='formatted-text text-wrap'>{meetingMinutes.resource.notes}</p>
                </Col>
                <Col span={6}>
                  <strong>Attendees</strong>
                  <p className='formatted-text'>{meetingMinutes.resource.attendees}</p>
                </Col>
              </Row>
              </div>
            )}
          />
        </Card>
        </Row>
      </React.Fragment>
    );
  }
}

MeetingMinuteList.propTypes = {
  meetingMinutes: PropTypes.arrayOf(PropTypes.object),
};

export default compose(
  connect(
    (state, props) => {
      const project = state.view.data[props.match.params.id];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const listpath = ['projects', props.match.params.id, 'meetingminutes'];
      if (!compArr(path, listpath) || loading) return { loading: true };
      const meetingMinutes = subViewSelector(state, props);
      return { meetingMinutes, project };
    },
    (dispatch, props) => ({
      loader: () => {
        dispatch(setViewPath(['projects', props.match.params.id, 'meetingminutes']));
        dispatch(getMeetingMinutesMultiple(props.match.params.id));
      },
      onNew: () => props.history.push(`/projects/${props.match.params.id}/meeting-minutes/new`),
      onDelete: (meetingMinutesId) => dispatch(deleteMeetingMinutes(props.match.params.id, meetingMinutesId)),
    })),
  withLoading
)(MeetingMinuteList);



// WEBPACK FOOTER //
// ./src/components/Projects/MeetingMinutes/MeetingMinuteList.js